const findResource = (resourceId, resources) => {
  return (resources || []).find(({ url, resourceId: rId, videoId }) =>
    [url, rId, videoId].includes(resourceId),
  );
};

const findResourceInCourseOutline = (resourceId, units) => {
  let foundResource;
  let unit;
  let subunitMetadata;
  let subunitTitle;
  let subunitType;
  units.find(({ unitId, number, title, resources, subunits, metadata }) => {
    unit = {
      unitId,
      number,
      title,
      metadata,
    };
    foundResource = findResource(resourceId, resources);
    if (foundResource) {
      return true;
    }

    subunits.find(
      ({ resources: subunitResources, metadata, displayName, type }) => {
        foundResource = findResource(resourceId, subunitResources);

        if (foundResource) {
          subunitMetadata = metadata;
          subunitTitle = displayName;
          subunitType = type;
        }

        return foundResource;
      },
    );

    return foundResource;
  });

  return foundResource
    ? {
        resource: foundResource,
        unit,
        subunitMetadata,
        subunitTitle,
        subunitType,
      }
    : null;
};

export default findResourceInCourseOutline;
